import { render, staticRenderFns } from "./AuthManage.vue?vue&type=template&id=a5ba682c&scoped=true&"
import script from "./AuthManage.vue?vue&type=script&lang=js&"
export * from "./AuthManage.vue?vue&type=script&lang=js&"
import style0 from "./AuthManage.vue?vue&type=style&index=0&id=a5ba682c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba682c",
  null
  
)

export default component.exports